import { cn } from "@/utils/theme";
import { Icon } from "@elaniintc/goes-design-system";
import type { ComponentProps } from "react";

interface DropdownListSeparatorProps {
  options: string[];
  icon?: ComponentProps<typeof Icon>;
}

const DropdownListSeparator = ({
  options,
  className,
  icon,
}: DropdownListSeparatorProps & ComponentProps<"div">) => {
  return (
    <div className={cn(`flex gap-2 items-center truncate px-2`, className)}>
      {icon && (
        <Icon {...icon} />
      )}
      <div className="flex items-center gap-2 flex-auto">
        {options.map((option, index) => (
          <div
            key={index}
            className="flex gap-2 items-center text-xs text-body-quiet truncate line-clamp-1 first:font-semibold first:text-body"
          >
            {option}
            {index < options.length - 1 && (
              <Icon type="far" name="chevron-right" />
            )}
          </div>
        ))}
        <span className="flex-auto border border-neutral-quiet"></span>
      </div>
    </div>
  );
};

export { DropdownListSeparator };
